// extracted by mini-css-extract-plugin
export var container = "HomeIntroSection-module--container--1As33";
export var introContainer = "HomeIntroSection-module--introContainer--2Gkrm";
export var hello = "HomeIntroSection-module--hello--3xRNT";
export var name = "HomeIntroSection-module--name--1YUVS";
export var description = "HomeIntroSection-module--description--ZV4xb";